import styled from 'styled-components'
import Button from '~/components/Buttons/Button'

export const ComponentStructure = styled.div`
  max-width: 632px;
  margin-inline: auto;
  text-align: center;
`

export const Image = styled.img`
  margin-bottom: 16px;

  @media (max-width: 768px) {
    width: 226px;
  }
`

export const Title = styled.h3`
  color: #303032;
  font-family: Barlow;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 32px;
  }
`

export const Description = styled.p`
  color: #303032;
  font-family: Barlow;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`

export const StyledButton = styled(Button)`
  max-width: 408px;
  margin: 0 auto;
`
